var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerateReportModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.756 14.2828L21.9757 14.5025H22.2863H31.2184C31.9671 14.5025 32.6851 14.7999 33.2144 15.3293C33.7438 15.8586 34.0412 16.5766 34.0412 17.3253V28.0438C34.0412 28.7925 33.7438 29.5105 33.2144 30.0398C32.6851 30.5692 31.9671 30.8666 31.2184 30.8666H9.78139C9.03273 30.8666 8.31473 30.5692 7.78535 30.0398C7.25596 29.5105 6.95856 28.7925 6.95856 28.0438V13.7525C6.95856 13.0038 7.25596 12.2858 7.78535 11.7564C8.31473 11.227 9.03273 10.9296 9.78139 10.9296H18.4028L21.756 14.2828Z",
    stroke: "#407DBB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4985 26.2575L24.0713 22.6847M20.4985 19.1118V26.2575V19.1118ZM20.4985 26.2575L16.9257 22.6847L20.4985 26.2575Z",
    stroke: "#407DBB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateReportModal);
export default __webpack_public_path__ + "static/media/generate_report_modal.b1f6e85ba853715281cbc1080162a60c.svg";
export { ForwardRef as ReactComponent };